(() => {
  angular.module('pims').directive('spinner', () => {
    return {
      restrict: 'E',
      template: `
        <div class="spinner-container">
          <div class="circle-spinner"></div>
        </div>
      `,
      scope: {
        on: '='
      }
    };
  });
})();